import React from 'react';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import { FaLeaf, FaSeedling } from 'react-icons/fa';
import './EmployeePage.css'; // Добавляем стили
import { API_URL } from './config'

function EmployeePage() {
    return (
        <>
            <HeaderLogged />
            <Container>
                <div className="cute-message">
                    <FaLeaf className="cute-message-icon" />
                    <h2>Employee Home Page is in progress...</h2>
                    <p>
                        We're working hard to bring you the best experience.
                    </p>
                    <p>
                        Please use the top menu to navigate through the available sections.
                    </p>
                    <FaSeedling className="cute-message-icon" />
                </div>
            </Container>
        </>
    );
}

export default EmployeePage;
